module.exports = __webpack_public_path__ + "media/public/img/arrow-left-e7b82ff7f0fc7a4635d63aa62acc43ab.png";